/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SimpleSubjectPlanDTO,
    SimpleSubjectPlanDTOFromJSON,
    SimpleSubjectPlanDTOFromJSONTyped,
    SimpleSubjectPlanDTOToJSON,
} from './SimpleSubjectPlanDTO';

/**
 * 
 * @export
 * @interface SpecialChangeRequestResponseDTO
 */
export interface SpecialChangeRequestResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof SpecialChangeRequestResponseDTO
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpecialChangeRequestResponseDTO
     */
    studentId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpecialChangeRequestResponseDTO
     */
    isApproved?: boolean;
    /**
     * 
     * @type {SimpleSubjectPlanDTO}
     * @memberof SpecialChangeRequestResponseDTO
     */
    sourceSubjectPlan?: SimpleSubjectPlanDTO;
    /**
     * 
     * @type {string}
     * @memberof SpecialChangeRequestResponseDTO
     */
    message?: string | null;
}

export function SpecialChangeRequestResponseDTOFromJSON(json: any): SpecialChangeRequestResponseDTO {
    return SpecialChangeRequestResponseDTOFromJSONTyped(json, false);
}

export function SpecialChangeRequestResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialChangeRequestResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'studentId': !exists(json, 'studentId') ? undefined : json['studentId'],
        'isApproved': !exists(json, 'isApproved') ? undefined : json['isApproved'],
        'sourceSubjectPlan': !exists(json, 'sourceSubjectPlan') ? undefined : SimpleSubjectPlanDTOFromJSON(json['sourceSubjectPlan']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function SpecialChangeRequestResponseDTOToJSON(value?: SpecialChangeRequestResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'studentId': value.studentId,
        'isApproved': value.isApproved,
        'sourceSubjectPlan': SimpleSubjectPlanDTOToJSON(value.sourceSubjectPlan),
        'message': value.message,
    };
}

